import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, Home } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { BUSINESS_SERVICES, RESIDENTIAL_SERVICES, IMAGES } from "@/data/siteData";

const Column = ({ Icon, eyebrow, title, image, items, testId, delay }) => (
  <Reveal delay={delay} className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-background">
    <div className="relative h-56 overflow-hidden">
      <img src={image} alt={title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-primary/30" />
      <span className="absolute left-6 top-6 flex h-11 w-11 items-center justify-center rounded-full bg-background text-primary">
        <Icon className="h-5 w-5" strokeWidth={1.5} />
      </span>
    </div>
    <div data-testid={testId} className="flex flex-1 flex-col p-8">
      <p className="eyebrow text-primary">{eyebrow}</p>
      <h3 className="mt-3 font-display text-2xl font-light text-foreground">{title}</h3>
      <ul className="mt-6 flex-1 space-y-3">
        {items.map((s) => (
          <li key={s.slug} className="flex items-start gap-3 text-sm text-foreground/80">
            <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-accent" />
            {s.title}
          </li>
        ))}
      </ul>
      <Link to="/services" className="mt-8 inline-flex items-center gap-1 text-sm font-medium text-primary transition-colors hover:text-accent">
        View details <ArrowUpRight className="h-4 w-4" />
      </Link>
    </div>
  </Reveal>
);

export const ServicesPreview = () => (
  <section data-testid="home-services-preview" className="bg-secondary/60 py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <SectionHeading
          eyebrow="What We Do"
          title="Two audiences. One standard of workmanship."
          description="Pro Solar Solutions fills the operations and maintenance gap for homeowners whose installer has moved on, and for solar businesses and manufacturers that need a certified field partner they can trust."
        />
      </Reveal>
      <div className="mt-16 grid gap-8 lg:grid-cols-2">
        <Column Icon={Building2} eyebrow="For Solar Businesses" title="Business Consulting Services" image={IMAGES.consulting} items={BUSINESS_SERVICES} testId="preview-business-card" delay={0} />
        <Column Icon={Home} eyebrow="For Homeowners" title="Residential Homeowner Services" image={IMAGES.residential} items={RESIDENTIAL_SERVICES} testId="preview-residential-card" delay={0.1} />
      </div>
    </div>
  </section>
);
